import styled from "@emotion/styled";

export const TitlePage = styled.div`
	font-weight: 700;
	font-size: 24px;
	line-height: 120%;
	letter-spacing: 0.2px;
	width: 100%;
	padding: 0 20px;
	white-space: nowrap;
	color: #ffffff;

	@media (min-width: 769px) {
		width: auto;
		text-align: left;
		padding: 0;
	}
`;
